
<template>
  <div >
    <b-card>
      <div class="row ml-1">
        <label class="font-weight-bold"> {{$t('dashboard.trainings.pending')}}</label>
        <b-button
          @click="goTo(`${routes.training.trainings}`)"
          size="sm"
          variant="primary"
          class="ml-auto mr-3 esep-blue-bg text-light"
          v-b-tooltip.hover
          :title="$t('dashboard.trainings.showPendingTrainings')"
        >
          <b-icon icon="arrow-right-circle-fill"></b-icon>
        </b-button>
      </div>
      <b-table
        id="pending-trainings-table"
        perPage="5"
        striped
        hover
        borderless
        :items="trainingsList"
        :fields="fields"
        responsive
        show-empty
        class="mt-2"
        thead-class="esep-blue-bg text-light"
      >

        <template v-slot:empty="">
          <h6>{{ $t("dashboard.trainings.emptyPendingTable") }}</h6>
        </template>
      </b-table>
    </b-card>
    

  </div>
</template>

<script>
import EsepService from "../../services/esep.service";
import { routes } from "../../services/routing.service";
import {handleApiError} from "../../services/error.service";
import { prettifyDate} from '../../services/utils';

const today = new Date();
export default {

  mounted() {
    this.getUpcomingTrainings();
  },
  data() {
    return {
      trainingsList: [],
      fields: [
        { key: "activityNo", label: "Αριθμός", sortable: true }, // needs to be translated
        { key: "module.title", label: "Περιγραφή", sortable: true ,filterByFormatted: true, thClass: 'text-left', tdClass: 'text-left' },
        { key: "leader.member.fullName", label: "Αρχηγός", sortable: true , thClass: 'text-left', tdClass: 'text-left'},
        { key: "applicationsExpireDate", label: "Ημ/νια Λήξης Αιτήσεων", sortable: true, formatter: 'prettifyDate'},
      ],
      routes: routes,
      criteria: {
        pageNo: 0,
        limit: 5,
        statuses: ['APPROVED','TO_BE_SUBMITTED'],
        search: this.$store.state.userInfo.orgMember.id,
        periodStartDate: today.toISOString().split('T')[0],
        orderby: 'ac.applicationsExpireDate'
      }
    }
  },
  methods: {
    goTo(link) {
      location.replace(link);
    },
    getUpcomingTrainings() {
      EsepService.getActivitiesByCriteria(this.criteria).then(
        (response) => {
          this.trainingsList = response.data;
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit('error:api', errorMessage);
        }
      )
    },
    prettifyDate(date) {
      return prettifyDate(date);
    },
   
  }
}
</script>

<style>

</style>